import { WakeUp } from 'common/interface/props';
import { UserAdminConfig } from 'components/user-admin/interfaces/user-admin.interface';
import { SearchType } from 'components/form/interfaces/user-admin.interface';

/**
 * @alias 쇼핑몰별 설정 맵
 */
export const USER_ADMIN_CONFIG: Record<WakeUp, UserAdminConfig | null> = {
  // 11번가
  ST11: {
    pageTitle: '네이버 상품 연동 관리',
    descriptionText: '네이버에서 11번가로 전송된 상품의 등록 및 업데이트 결과를 확인하실 수 있습니다.',
    highlightText: '등록 또는 업데이트에 실패한 상품은 실패 사유를 확인한 후 네이버 스마트스토어센터에서 상품 정보를 수정해주시기 바랍니다.',
    additionalText:
      "상품 정보 수정 시, 매일 1회 자동 업데이트를 통해 수정 내용이 반영되며 '즉시 업데이트' 기능을 사용하시면 수정 내용이 보다 빠르게 11번가 상품에 반영됩니다. \n(단, 실제 반영까지는 다소 시간이 소요될 수 있습니다.)", 
    sellerCenterLinks: [
      {
        url: 'https://soffice.11st.co.kr/view/main',
        text: '11번가 판매자센터 이동',
      },
      {
        url: 'https://sell.smartstore.naver.com/',
        text: '스마트스토어 판매자센터 이동',
      },
    ],
    searchOptions: [
      { value: SearchType.SCRAP_PROD_CODE, label: '네이버 상품번호' },
      { value: SearchType.WAKEUP_PROD_CODE, label: '11번가 상품번호' },
      { value: SearchType.SCRAP_PROD_NAME, label: '네이버 상품명' },
    ],
    scrapProdCodeLabel: '네이버 상품번호',
    scrapProdNameLabel: '네이버 상품명',
    wakeupProdCodeLabel: '11번가 상품번호',
    getScrapProductUrl: (scrapShopEtc2: string, scrapProdCode: string) => {
      if (scrapShopEtc2 && scrapProdCode) {
        return `https://smartstore.naver.com/${scrapShopEtc2}/products/${scrapProdCode}`;
      }
      return undefined;
    },
    getWakeupProductUrl: (wakeupProdCode: string) => {
      if (wakeupProdCode) {
        return `https://www.11st.co.kr/products/${wakeupProdCode}`;
      }
      return undefined;
    },
  },
  COUPANG: null,
  KAKAO: null,
  ALWAYZ: null,
  ESM: null,
  TOSS: null,
  ADMIN: null,
  ALL: null,
  ESM_ALL: null,
};
